export default __webpack_public_path__ + "static/media/hero.ce932ef4.png";